module.exports = __webpack_public_path__ + "media/customizations/vistaatmontaine/back-34acb8591287eeba8d34c7341b78fa49.jpg";